export const CITY_SEARCH_URL = 'https://nominatim.openstreetmap.org/search/?q='
export const CITY_SEARCH_QUERY_REST = '&limit=5&format=json'
export const LLD_SEARCH_URL = 'lsd/search/'
export const CITY = 'City'
export const LATLON = 'Lat/Lon'
export const LLD = 'LLD'
